/**
 * Warm browser cache + decode for gameplay images and SFX before first interaction.
 */
import * as C from "../config/constants.js";
import { MergeAssets } from "./merge-assets.js";
import { mergeTierImageUrl } from "./merge-tier-urls.js";
import { gameplayStaticImageUrls } from "./game-image-urls.js";
import { preloadImageUrl, preloadImageUrls } from "./image-cache.js";

/** Fall / HUD / overlay sprites (not merge-chain tiers). */
export const GAMEPLAY_STATIC_IMAGE_URLS = gameplayStaticImageUrls();

/**
 * Tier configs whose PNGs we preload (respects `MAX_MERGE_EVOLUTION_TIERS`).
 * Keeps requests aligned with shipped assets and active progression cap.
 */
function evolutionChainForPreload() {
  var chain = C.EVOLUTION_CHAIN || [];
  var cap = C.MAX_MERGE_EVOLUTION_TIERS;
  var n = chain.length;
  if (cap != null) {
    var parsed = Math.floor(Number(cap));
    if (isFinite(parsed)) {
      n = Math.max(1, Math.min(chain.length, parsed));
    }
  }
  return chain.slice(0, n);
}

/**
 * Merge tier PNGs for evolution dock, pickups, and flask bodies.
 * @returns {string[]}
 */
export function collectMergeImageUrls() {
  var chain = evolutionChainForPreload();
  var seen = {};
  var urls = [];
  for (var i = 0; i < chain.length; i++) {
    var aid = chain[i] && chain[i].assetId;
    if (!aid || seen[aid]) continue;
    seen[aid] = true;
    var url = mergeTierImageUrl(aid);
    if (url) urls.push(url);
  }
  return urls;
}

/**
 * @returns {string[]}
 */
export function collectAllGameImageUrls() {
  var seen = {};
  var out = [];
  function add(url) {
    if (!url || seen[url]) return;
    seen[url] = true;
    out.push(url);
  }
  GAMEPLAY_STATIC_IMAGE_URLS.forEach(add);
  collectMergeImageUrls().forEach(add);
  return out;
}

/**
 * @param {{ soundManager?: { preloadAll?: () => Promise<unknown> } }} [opts]
 * @returns {Promise<void>}
 */
export async function preloadAllGameAssets(opts) {
  if (typeof window === "undefined") return;

  opts = opts || {};
  var tasks = [];

  if (MergeAssets && typeof MergeAssets.preloadAll === "function") {
    tasks.push(MergeAssets.preloadAll());
  }

  tasks.push(preloadImageUrls(collectAllGameImageUrls()));

  if (opts.soundManager && typeof opts.soundManager.preloadAll === "function") {
    tasks.push(opts.soundManager.preloadAll());
  }

  await Promise.all(tasks);
}